import React, { useEffect, useState } from 'react'
import { Table, Card, Button, Modal, Form, Input, message } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { getConfigs, updateConfig, SystemConfig } from '../../api/admin'

const Configs: React.FC = () => {
  const [configs, setConfigs] = useState<SystemConfig[]>([])
  const [loading, setLoading] = useState(true)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedConfig, setSelectedConfig] = useState<SystemConfig | null>(null)
  const [form] = Form.useForm()

  useEffect(() => {
    loadConfigs()
  }, [])

  const loadConfigs = async () => {
    try {
      const data = await getConfigs()
      setConfigs(data)
    } catch {
      // 错误已在拦截器中处理
    } finally {
      setLoading(false)
    }
  }

  const handleEdit = (config: SystemConfig) => {
    setSelectedConfig(config)
    form.setFieldsValue({
      value: config.value,
      description: config.description
    })
    setModalVisible(true)
  }

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields()
      if (!selectedConfig) return

      await updateConfig(selectedConfig.key, values.value, values.description)
      message.success('配置已更新')
      setModalVisible(false)
      loadConfigs()
    } catch {
      // 表单验证失败
    }
  }

  const columns = [
    {
      title: '配置项',
      dataIndex: 'key',
      key: 'key',
      render: (key: string) => <code>{key}</code>
    },
    {
      title: '值',
      dataIndex: 'value',
      key: 'value'
    },
    {
      title: '描述',
      dataIndex: 'description',
      key: 'description'
    },
    {
      title: '更新时间',
      dataIndex: 'updated_at',
      key: 'updated_at',
      render: (date: string) => new Date(date).toLocaleString('zh-CN')
    },
    {
      title: '操作',
      key: 'action',
      render: (_: unknown, record: SystemConfig) => (
        <Button
          type="link"
          icon={<EditOutlined />}
          onClick={() => handleEdit(record)}
        >
          编辑
        </Button>
      )
    }
  ]

  return (
    <div>
      <h2 style={{ marginBottom: 24 }}>⚙️ 系统配置</h2>

      <Card>
        <Table
          columns={columns}
          dataSource={configs}
          rowKey="key"
          loading={loading}
          pagination={false}
        />
      </Card>

      <Modal
        title={`编辑配置: ${selectedConfig?.key}`}
        open={modalVisible}
        onOk={handleSubmit}
        onCancel={() => setModalVisible(false)}
        okText="保存"
        cancelText="取消"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="value"
            label="配置值"
            rules={[{ required: true, message: '请输入配置值' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="description"
            label="描述"
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default Configs
